import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'reducers/rootReducer';
import { match } from 'react-router';
import { setCurrentAssignmentAction } from 'actions/assignment';
import { justKeepEmailAction } from 'actions/authorization';
import { IsLoading } from 'types/api';

const mapStateToProps = ({ assignmentReducer, mobileReducer, authReducer }: RootState) => ({
  assignment: assignmentReducer.assignment,
  isMobileScreen: mobileReducer.isMobileScreen,
  email: authReducer.email
});
const mapDispatchToProps = { setCurrentAssignmentAction, justKeepEmailAction };
export const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

type ComponentProps = { match: match<{ token: string }> };

export type Props = ReduxProps & ComponentProps;
export type State = IsLoading;
